import AddressImg from "../../../../assets/icons/address.svg"
import LibraryImg from "../../../../assets/icons/library.svg"
import RentHistoryImg from "../../../../assets/icons/rentHistory.svg"
import UserImg from "../../../../assets/icons/user.svg"

export const navProfileTabs = [
  {
    "key" :"account",
    "label": "Account",
    "icon": UserImg
  },
  {
    "key" :"addresses",
    "label": "Addresses",
    "icon": AddressImg
  },
  {
    "key" :"library",
    "label": "Library",
    "icon": LibraryImg
  },
  {
    "key" :"rentHistory",
    "label": "Rent History",
    "icon": RentHistoryImg
  }
]